import { render, staticRenderFns } from "./garden17.vue?vue&type=template&id=f889b112&scoped=true"
import script from "./garden17.vue?vue&type=script&lang=js"
export * from "./garden17.vue?vue&type=script&lang=js"
import style0 from "./garden17.vue?vue&type=style&index=0&id=f889b112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f889b112",
  null
  
)

export default component.exports